<template>
  <div class="n_rule">
    <!-- <iframe v-if="isShow" :src="url" width="100%" height="1000vh"></iframe> -->
    <div>
      <pdf
        :src="url"
        ref="pdf"
        width="100vw"
        style="transform:scale(1.2);padding:50px 0 80px;"
        v-for="i in numPages"
        :key="i"
        :page="i"
      ></pdf>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: { pdf },
  data() {
    return {
      url: '',
      isShow: false,
      numPages: 1, // pdf 总页数
    }
  },
  mounted() {
    switch (this.$route.query.id) {
      case '1':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/商品配送.pdf'
        break
      case '2':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/系统交易规则.pdf'
        break
      case '3':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/开具发票注意事项.pdf'
        break
      case '4':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/消费者权益保护.pdf'
        break
      case '5':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/退换货政策.pdf'
        break
      case '6':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/酒水平台相关规则.pdf'
        break
      case '7':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/食品安全投诉举报处理制度.pdf'
        break
      case '8':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/食品安全违法行为制止及报告制度.pdf'
        break
      case '9':
        this.url =
          'https://yjdd-static-resource.oss-cn-beijing.aliyuncs.com/file/用户服务协议.pdf'
        break
    }
    this.getNumPages()
  },
  methods: {
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.url)
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages
          this.isShow = true
        })
        .catch((err) => {
          this.err = err
          console.error('pdf 加载失败', err)
        })
    },
  },
}
</script>

<style>
.n_rule {
  width: 100%;
  overflow: hidden;
  padding-top: 50px;
}
</style>